/* eslint-disable react/prop-types */
import CustomIcon from '@Assets/images/icons';
import React, { CSSProperties } from 'react';
import './style.css';
import { Container, LabelStyled } from './styled';

type SwitchProps = {
	containerClassName?: string;
	ContainerStyle?: CSSProperties;
} & React.HTMLProps<HTMLInputElement>;

export default function Switch({
	label,
	checked,
	name,
	onChange,
	containerClassName = '',
	ContainerStyle = {},
	disabled,
	...rest
}: SwitchProps) {
	return (
		<Container style={ContainerStyle} className={containerClassName}>
			<div className="form-check form-switch form-check-custom form-check-solid d-flex align-items-center">
				{disabled ? (
					<CustomIcon icon="swichblocked" style={{ cursor: 'not-allowed' }} />
				) : (
					<input
						className="form-check-input"
						type="checkbox"
						name={name}
						checked={checked}
						onChange={onChange}
						{...rest}
					/>
				)}
				<LabelStyled className="form-check-label switch-label">
					{label}
				</LabelStyled>
			</div>
		</Container>
	);
}
